import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROTECTED, ADMINISTRATION } from '@/lib/constants/routes';

// Redirect compat: i finanziamenti vivono ora sotto `/administration` tab `debts`.
export const Route = createFileRoute(
  '/protected/_layout/documents/_layout/debts/new'
)({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: `${PROTECTED}${ADMINISTRATION}/new`,
      search: { ...search, subTab: 'debts' },
    });
  },
  component: () => null,
});
